import { useDb } from '~/use/indexedDb/setup'
import type {PowerOfAttorneysByProperty} from '~/models/powerOfAttorney';
import cloneDeep from 'lodash/cloneDeep';

const { dbPromise } = useDb()

const getPowersOfAttorneyByPropertyId = async (propertyId: string): Promise<PowerOfAttorneysByProperty | undefined> => {
  if (!propertyId) {
    return
  }
  try {
    return (await dbPromise).get('powerOfAttorneysByProperty', propertyId)
  } catch (e) {
    console.error('powerOfAttorneysDb: get', e)
  }
}

const putPowersOfAttorneyByPropertyId = async (value: PowerOfAttorneysByProperty): Promise<string> => {
  try {
    return (await dbPromise).put('powerOfAttorneysByProperty', cloneDeep(value))
  } catch (e) {
    console.error('powerOfAttorneysDb: put', e)
  }
}

export const usePowerOfAttorneysDb = () => ({
  getPowersOfAttorneyByPropertyId,
  putPowersOfAttorneyByPropertyId,
})
